<template>
  <div>
    <div class="ListBodyContent">
      <div
        :class="liststyle=='list' ? 'itemWrapList':'ItemWrap'"
        v-for="(item,index) in list"
        :key="index"
        @click="Jump(item.goodsid)"
      >
        <div class="ItemImg">
          <img src="../assets/frame-img/logo.png" class="logo">
          <img :src="item.img | thumbnail(750,750)">
        </div>
        <div class="ItemMsg">
          <p class="ItemName">{{item.name}}</p>
          <p class="ItemPrice">￥{{item.price}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { List } from "vant";
import Vue from "vue";
Vue.use(List);
export default {
  props: {
    list: {
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    liststyle: function() {
      return this.$store.state.system.listStyle;
    }
  },
  created() {},
    methods: {
      Jump(id){
        this.$router.push({
          name: "detail", // 路由的名称
          query: {
            id: id
          }
        });
      }
    }
};
</script>
<style lang="less" scoped>
@import url("../style/skin.less");
.logo{
  position: absolute;
  top: 10px !important;
  width: 30px !important;
  height: 15px !important;
  left: 68% !important;
  z-index: 1;
}
.ListBodyContent {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .ItemWrap {
    box-sizing: border-box;
    width: 185.5px;
    margin-bottom: 4px;
    border-radius: 4px;
    overflow: hidden;
    .ItemImg {
      position: relative;
      overflow: hidden;
      height: 185.5px;
      img {
        float: left;
        width: 100%;
      }
    }
    .ItemMsg {
      padding: 0px 6px;
      background: #fff;
      .ItemName {
        font-size: 15px;
        overflow:hidden;
        text-overflow:ellipsis; 
        white-space: nowrap;
      }
      .ItemPrice {
        font-size: 16px;
        color: @text;
        margin-top: 5px;
        font-weight: 700;
      }
    }
  }
  .ItemWrap:nth-child(odd) {
    margin-right: 4px;
  }

  .itemWrapList {
    display: flex;
    padding: 7.5px;
    background: #fff;
    flex-flow: row;
    border-bottom: 1px solid #eee;
    .ItemImg {
      width: 110px;
      height: 110px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .ItemMsg {
      padding: 0px 6px;
      width: 250px;
      .ItemName {
        margin-top: 5px;
        // line-height: 38px;
        width: 100%;
        height: 40px;
        font-size: 15px;
        display: -webkit-box;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .ItemPrice {
        margin-top: 5px;
        color:  @text;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
}
</style>